















import { AccountTypeEnum, DistrictModel, TenantUserModel } from '@/libs/Api';
import { authStore } from '@/libs/auth/+store/store';
import { AuthGetter } from '@/libs/auth/models/auth-state';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { districtsStore } from '@/libs/districts/+state/store';
import { tenantUsersStore } from '@/libs/tenants/+state/store';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

@Component({ })
export default class DistrictSelect extends Vue {

    editable = true;

    @Prop({ default: "" }) label!: string;
    @VModel() innerValue!: string;
    @Prop() type!: string;
    @Prop() placeholder!: string;
    @Prop() readonly!: boolean;
    @Prop() rules!: any[];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: true }) clearable!: boolean;
    @Prop({ default: true }) useDefaultValue!: boolean;

    @Watch("innerValue")
    innerValueChanged (v: string) {
        this.$emit("change", v);
    }

    get items(): DistrictModel[] {
        let items = districtsStore.useGetter(CrudGetter.Data) as DistrictModel[];
        const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
        if (tenantUser.accountType == AccountTypeEnum.Manager || tenantUser.accountType == AccountTypeEnum.Worker || tenantUser.accountType == AccountTypeEnum.Volunteer) {
            items = items.where(x => x.id == tenantUser.mainDistrictId).toArray();
            this.$emit("input", tenantUser.mainDistrictId);
            this.editable = false;
        }
        return items;
    }

}
